import { render, staticRenderFns } from "./ConfigViewPermissions.vue?vue&type=template&id=d9479b64&"
import script from "./ConfigViewPermissions.vue?vue&type=script&lang=js&"
export * from "./ConfigViewPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports